import React from 'react';
import PageTransition from "../components/PageTansition";
import UbicacionCompoent from "../components/UbicacionComponent";


const Cotiza = () => {
    return (
        <div className="page cotizar">
            {/* <PageTransition /> */}

            <div className="con">

                <section id="hero">
                    <div className="logo">
                        <div className="phone">
                            <img
                                src="/images/cotizar/logo_celular.png"
                                alt="Logo Edificio Almirante"
                            />
                        </div>
                    </div>

                    <p className="texto">COTIZA AQUÍ <small>TU NUEVA INVERSIÓN</small></p>
                    <div className="note">
                        <p className="texto-note">Maximiza tu inversión <span>con altos rendimientos</span>   en Airbnb</p>
                    </div>
                </section>

                <section id="formulario">
                    <p className="titulo-tablet">Ingresa tus datos</p>
                    <iframe src="https://forms.inmorecreative.com/form/B6uJG8TwB4nXATm?buttonbg=B54949"></iframe>
                </section>
            </div>

            <UbicacionCompoent />
        </div>
    )
}

export default Cotiza